import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const EmbeddedSectionStyles = styled.div`
  padding: 32px 0;
  background-color: ${(props) => (props.$bgColor ? props.$bgColor : '#fff')};

  > div {
    margin-bottom: 0px;
    margin-top: 3em;
  }

  .embedded-content-container {
    margin: 16px;
    .embedded-content-header {
      text-align: center;
    }

    .embedded-content-subheader {
      text-align: center;
      margin-top: 12px;
    }

    .embedded-content-video {
      width: 100%;
      margin: 24px 0;
    }
  }

  a {
    text-decoration: none;
  }

  .wistia_responsive_padding {
    padding: 0 !important;

    .wistia_responsive_wrapper {
      position: relative !important;
    }
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    .embedded-content-container {
      width: 80%;
      margin: 64px auto;
    }
  }
`;

export default EmbeddedSectionStyles;
